import { List, Map } from 'immutable';

// constants
import { RESULT_FETCH_ALL_FOR_CHAPTER, RESULT_CLEAR } from '../constants/resultTypes';
import { NOTE_TAG_BULK_REMOVE } from '../constants/noteTypes';

// lib
import httpReducer from '../lib/httpReducer';

function removeTagFromResultPnm(state, action) {
  const { payload, meta } = action;
  const { data } = payload || {};

  // Only update if notes were actually affected
  const notesAffected = Array.isArray(data && data.notes) ? data.notes.length : 0;
  if (meta.loading || !data || !notesAffected) {
    return state;
  }

  const oldData = state.get('data') || List();
  const newData = oldData.map((pnm) => {
    if (String(pnm.get('id')) !== String(data.pnm)) {
      return pnm;
    }

    const tags = pnm.get('tags') || List();
    const tagIndex = tags.findIndex(
      (t) => (t.get('_id') || '').toString() === (data.tag || '').toString()
    );

    return tagIndex === -1 ? pnm : pnm.set('tags', tags.splice(tagIndex, 1));
  });

  return state.set('data', newData);
}

export default (state = Map({ displayList: true }), action) => {
  switch (action.type) {
    case NOTE_TAG_BULK_REMOVE: return removeTagFromResultPnm(state, action);
    case RESULT_FETCH_ALL_FOR_CHAPTER: return httpReducer(state, action);
    case RESULT_CLEAR: return Map();
    default: return state;
  }
};
